import * as React from 'react';
import Header from '../common/Header';
import AdminFooter from '../common/AdminFooter';

export interface Props {
    isRegisteredUserFacing?: boolean;
    showHeaderPhoneNumber?: boolean;
}

const redirectUrlMap = {
    'http://localhost:3000': 'https://explore-dev.tour24.io',
    'https://tour24-ui-development.azurewebsites.net': 'https://explore-dev.tour24.io',
    'https://app-dev.tour24now.com': 'https://explore-dev.tour24.io',
    'https://app.tour24now.com': 'https://explore.tour24.io',
    'https://app-dev.tour24.io': 'https://explore-dev.tour24.io',
    'https://app.tour24.io': 'https://explore.tour24.io',
    'https://app-staging.tour24.io': 'https://explore-staging.tour24.io',
    'https://app-staging.tour24now.com': 'https://explore-staging.tour24.io',
    'https://tour24-ui-staging.azurewebsites.net': 'https://explore-staging.tour24.io'
};

class StandardLayout extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        const url = new URL(window.location.href);
        const redirectUrl = redirectUrlMap[url.origin as keyof typeof redirectUrlMap];
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }

    render() {
        const isRegisteredUserFacing =
            this.props.isRegisteredUserFacing !== undefined
                ? this.props.isRegisteredUserFacing
                : true;
        const showPhoneNumber =
            this.props.showHeaderPhoneNumber !== undefined
                ? this.props.showHeaderPhoneNumber
                : false;
        return (
            <div className="flex-root">
                <Header
                    isRegisteredUserFacing={isRegisteredUserFacing}
                    showPhoneNumber={showPhoneNumber}
                />
                {this.props.children}
                <AdminFooter />
            </div>
        );
    }
}

export default StandardLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/StandardLayout.tsx